import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { Link, useHistory, useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { Button } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  Row,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

const PNReportDriverCostAdvance = () => {
  const printRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [smOption, setSmOption] = useState(false);
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [filter, setFilter] = useState({
    monthYear: searchParams.get('monthYear') || moment().format("YYYY-MM"),
  });

  useEffect(() => {
    const newParams = new URLSearchParams({
      monthYear: filter.monthYear,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    const params = {
      monthYear: filter.monthYear,
    }

    GET(
      `/pn/report-driver-cost-advance`,
      params,
      true
    ).then((resp) => {
      const { data } = resp;
      setData(data.rows);
      setSummary(data.summary);
    });
  }, [filter]);

  const colTable = [
    {
      Header: "Tên tài xế",
      accessor: (item) => (item.user?.fullName),
    },
    {
      Header: "Đầu kỳ(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.firstDebt || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Chi phí cá nhân(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.personalCost || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Ứng trước(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={(item.advanceSalary || 0) * -1}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Cuối kỳ(đ)",
      className: 'text-right font-weight-bold',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.lastDebt || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
  ];

  const exportExcel = () => {
    const params = new URLSearchParams({
      monthYear: filter.monthYear,
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/pn/report-driver-cost-advance-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Báo cáo"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="d-inline-block mr-3">
                        <Link to={`/pn/summary-statement?type=DRIVER_COST_ADVANCE`}>
                          <Button color="light">Cập nhật đầu kỳ</Button>
                        </Link>
                      </div>
                    </li>
                    <li>
                      <div className="d-inline-block mr-3">
                        <ReactToPrint
                          trigger={() => <Button>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="ml-3">
                          Xuất excel
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div
            id="DataTables_Table_1_wrapper"
            className="dataTables_wrapper dt-bootstrap4 no-footer bg-white"
          >
            <div className="my-3">
              <Row>
                <Col md={12}>
                  <div ref={printRef}>
                    <h5 className="text-center mt-2">
                      CÔNG TY TNHH CƠ KHÍ VẬN TẢI PHƯƠNG NAM
                    </h5>
                    <h5 className="text-center">Tổng hợp chi phí và ứng tài xế tháng {moment(filter.monthYear, 'YYYY-MM').format('MM-YYYY')}</h5>

                    <Table
                      columns={colTable}
                      data={data}
                      notShowPagi={true}
                      customRow={() =>
                        <tr className="font-weight-bold">
                          <td><span>Tổng(đ)</span></td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.firstDebt || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.personalCost || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={(summary.advanceSalary || 0) * -1}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.lastDebt || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                        </tr>
                      }
                    ></Table>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default PNReportDriverCostAdvance;
